<div class="row">
  <div class="col col-12 p-0" #chartQuantityPmContainer>
    <ngx-charts-bar-vertical [view]="view" [scheme]="bluePalette" [results]="quantityPerMonth" [gradient]="gradient"
      [xAxis]="showXAxis" [yAxis]="showYAxis" [legend]="showLegend" [showXAxisLabel]="showXAxisLabel"
      [showYAxisLabel]="showYAxisLabel" [xAxisLabel]="xAxisLabel" [yAxisLabel]="yAxisLabel"
      [maxXAxisTickLength]="maxXAxisTickLength" [trimXAxisTicks]="trimXAxisTicks" [rotateXAxisTicks]="rotateXAxisTicks">
    </ngx-charts-bar-vertical>
  </div>
</div>
<div class="row pt-3">
  <div class="col col-12">
    <p class="text-3 mb-3 text-center text-primary">Audit volumes by month</p>
  </div>
</div>